import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define the API slice
export const authSlice = createApi({
  reducerPath: 'auth',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://mecfuture.mec.edu.om/api/', // Base URL for your API
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      headers.set('nlms-api-key', '0612b32b39f4b29f48c5c5363028ee916bb99Singularis');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    createUser: builder.mutation({
      query: (credentials) => ({
        url: '/joy/signup',
        method: 'POST',
        body: credentials,
      })
    })
  }),
});

// Export the auto-generated hooks
export const {
  useLoginMutation,
  useCreateUserMutation
  // Export additional hooks if needed
} = authSlice;
